export default __webpack_public_path__ + "static/media/selectTeam2.9fb4b3c7.mp3";